module.exports = __webpack_public_path__ + "static/blume-ipad-2e15925a444de6ae5cda317a9f321ee5.jpg";